// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import Difficulty from "./difficulty_type";

export default {
  userId: __t.u64(),
  get difficulty() {
    return Difficulty;
  },
  maxPlayers: __t.u8(),
  shieldsPerPlayer: __t.u8(),
  penaltyPerShieldMs: __t.u32(),
  finishWindowMs: __t.u32(),
  finishWindowStrict: __t.bool(),
  chordingEnabled: __t.bool(),
  hostOnlyReset: __t.bool(),
  regionId: __t.string(),
};
